const form = {
  formId: "add-role",
  formField: {
    roleName: {
      name: "name",
      label: "role name",
      type: "text",
      placeholder: "eg. Admin",
      errorMsg: "Role name is required.",
    },
    userType: {
      name: "user_type",
      label: "user type",
      type: "select",
      options: [
        { value: "tenant", label: "Tenant" },
        { value: "internal", label: "Internal" },
      ],
      placeholder: "eg. tenant",
      errorMsg: "User type is required.",
    },
    description: {
      name: "description",
      label: "description",
      type: "text",
      placeholder: "eg. This is an information about the role",
      errorMsg: "Description is required.",
    },
    status: {
      name: "status",
      label: "status",
      type: "select",
      options: [
        { value: "active", label: "Active" },
        { value: "suspended", label: "Suspended" },
        { value: "blocked", label: "Blocked" },
      ],
      placeholder: "eg. Active",
      errorMsg: "Status is required.",
    },
  },
};

export default form;
